// extracted by mini-css-extract-plugin
export default {"topCaptionContainer":"InventoryDetailsTableArea_topCaptionContainer__aNp5F"};